import { gql } from '@apollo/client';

export default gql`
  query AllTagsQuery($orderBy: [TagsOrderBy!], $condition: TagCondition!) {
    tags: allTags(orderBy: $orderBy, condition: $condition) {
      nodes {
        id
        tag
      }
    }
  }
`;
